import { render, staticRenderFns } from "./Footer-stepbar.vue?vue&type=template&id=6bd56a6e"
import script from "./Footer-stepbar.vue?vue&type=script&lang=js"
export * from "./Footer-stepbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports